import { format } from "date-fns";
import { Post } from "../../api/LegacyReportsApi";
import { SocialIcon } from "../../utils/social-icon";
import ItemFlags from "../common/ItemFlags";
import LegacyPostMedia from "./LegacyPostMedia";

interface PostProps {
  post: Post;
}

function getDisplayPostType(postType: "LIKED" | "SHARED" | "ORIGINAL") {
  switch (postType) {
    case "ORIGINAL":
      return "Posted";
    case "SHARED":
      return "Shared";
    case "LIKED":
      return "Liked";
  }
}

function getDisplayProfileType(profileType: string) {
  return (
    profileType.charAt(0).toUpperCase() + profileType.slice(1).toLowerCase()
  );
}

function LegacyPostCard({ post }: PostProps) {
  return (
    <div className="bg-white p-4 pb-6 break-inside-avoid print:break-inside-avoid font-roboto text-[15px] text-[#5b5b5b] shadow-md">
      <div className="flex items-start pb-4">
        <SocialIcon url={post.url || ""} className="!w-8 !h-8" />
        <div className="ml-2 flex-grow">
          <h4 className="text-[13px] tracking-[0.3px] text-[#126798] m-0">
            {getDisplayPostType(post.postType)}
            {post.profileType && (
              <span>
                {" "}
                on{" "}
                <strong className="font-semibold">
                  {getDisplayProfileType(post.profileType)}
                </strong>
              </span>
            )}
          </h4>
          <span className="mt-0.5 text-[11px] tracking-[0.3px] text-[#84969f] flex items-center">
            <svg
              className="w-3 h-3 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {format(
              typeof post.date === "string"
                ? parseInt(post.date, 10)
                : post.date,
              "MMM dd, yyyy"
            )}
          </span>
        </div>
      </div>

      <div className="text-[13px] tracking-[0.4px] text-[#2C3E50] break-words">
        {post.text}
      </div>

      <LegacyPostMedia mediaEntries={post.mediaEntries} />

      {(post.flaggedKeywords.length > 0 ||
        post.flaggedStemmableKeywords.length > 0 ||
        post.flaggedSensitivities.length > 0) && (
        <div>
          <hr className="my-4 border-t border-gray-200" />
          <ItemFlags
            behaviorFlags={post.flaggedSensitivities}
            keywordFlags={[
              ...post.flaggedKeywords,
              ...post.flaggedStemmableKeywords,
            ]}
          />
        </div>
      )}

      <div className="flex justify-end pt-4">
        {post.url && (
          <a
            href={post.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[13px] font-medium tracking-[0.3px] text-[#2B95D6] hover:text-[#1E88C3] active:text-[#126798]"
          >
            View link
          </a>
        )}
      </div>
    </div>
  );
}

export default LegacyPostCard;
